<template>
  <transition name="scroll" appear>
    <div
      v-if="scrollY < 30"
      class="iv2-home__scroll-bar position-absolute d-none d-xl-block"
      @click="scroll"
    >
      <span class="iv2-home__scroll-bar-text">{{
        $store.state.themeLang.general.scroll
      }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      scrollY: 0,
    };
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    handleScroll() {
      this.scrollY = window.scrollY;
    },

    scroll() {
      var section = document.getElementsByClassName("iv2-global__top-content");
      var header = section[0].clientHeight;
      var height = window.innerHeight - header;
      window.scrollTo({
        top: height,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style lang="scss">
.iv2-home__scroll-bar {
  left: 30px;
  bottom: 150px;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.3em;
  cursor: pointer;
  z-index: 11;
  mix-blend-mode: exclusion;
  color: #fff;

  &::after {
    content: "";
    width: 60px;
    position: absolute;
    left: 80px;
    top: 50%;
    border-top: 1px solid #fff;
  }

  &.scroll-enter-active,
  &.scroll-leave-active {
    transition: all 1s ease;
  }

  &.scroll-enter,
  &.scroll-leave-to {
    transform: rotate(90deg) translateX(-50px) !important;
    opacity: 0;
  }
}
</style>
